import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "services/auth.service";
import Button from "components/button/button";

function PublicHeader({ showLogout = false }: { showLogout?: boolean }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isOnboarding = pathname.startsWith("/on-boarding");
  const shouldShowLogout = isOnboarding || showLogout;

  const handleLogoClick = () => {
    if (!isOnboarding && !showLogout) {
      navigate("/login");
    }
  };

  const handleLogout = async () => {
    await logout();
    localStorage.removeItem("userInfo");
    window.location.reload();
  };

  return (
    <nav className="flex items-center justify-between h-14 bg-brand border-b border-border px-6">
      <button
        type="button"
        className={`flex items-center bg-transparent border-none p-0 ${shouldShowLogout ? "cursor-default" : "cursor-pointer"}`}
        onClick={handleLogoClick}
        aria-label="Go to login"
      >
        <img
          className="w-[218px] h-6"
          src="/assets/brand/CareerSight Logo Web-03.png"
          alt="CareerSight"
        />
      </button>
      {shouldShowLogout && (
        <Button
          type="button"
          variant="secondary"
          onClick={handleLogout}
        >
          Log Out
        </Button>
      )}
    </nav>
  );
}

export default PublicHeader;
